import { Component, OnInit ,HostListener, OnDestroy} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit,OnDestroy {
  private modalRef: NgbModalRef;

  epochNow = (new Date).getTime();
  sessionTimeSubsribe:any;
  sessionTime:number = (new Date).getTime();
  @HostListener('mousemove', ['$event'])
  onMousemove(event: MouseEvent) { this.epochNow = (new Date).getTime(); }
  constructor(private _snackBar: MatSnackBar,public router :Router,
    public modalService: NgbModal
    ) { }

  ngOnInit() {
    this.sessionTimeSubsribe = setInterval(() => {
      this.sessionTime= (new Date).getTime();
      const differenceInSeconds = Math.floor((this.sessionTime - this.epochNow) / 1000);
      if(differenceInSeconds > 600) {
          localStorage.clear();
        this.router.navigate(["signin"]);
        this._snackBar.open("Your session has expired","",{
          duration: 3000,
          horizontalPosition:'right',
          verticalPosition:'top',
          panelClass: ['failure']
        });
        this.modalService.dismissAll();
        return 
      }
    }, 5000);
  }
  ngOnDestroy(): void {
    if (this.sessionTimeSubsribe) {
      clearInterval(this.sessionTimeSubsribe);
    } 
  }

}
